/*
  The following enum represents the features that are currently under the beta testing program
  Values should match the ones at PersonBetaTestService.java in the oe-profile-service
*/

export enum BetaFeatureType {
  // GAMIFICATION = 'GAMIFICATION'
  PC_RESERVATION = 'PC_RESERVATION',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/beta-feature-type.ts